import { SharePlatform } from 'js/journals/shareText';

export type ArticleShareOption =
  | SharePlatform
  | 'clipboard'
  | 'facebook'
  | 'reddit'
  | 'whatsapp'
  | 'wechat';

export const articleShareUrl = (
  articleUrl: string,
  option: ArticleShareOption,
): string => {
  const url = new URL(articleUrl);
  url.searchParams.set(
    'src',
    option === 'wechat' ? 'wechat' : `share_${option}`,
  );
  return url.toString();
};
